export default {
  route: {
    Permission: '权限系统',
    RoleFrontPermission: '前台权限',
    RoleBackPermission: '后台权限',
    Setting: '系统设置',
    UserManager: '用户管理',
    UserList: '用户列表',
    AddressManager: '地区管理',
    AddressList: '地区列表',
    AddAddress: '新增地区',
    MeterManager: '设备管理',
    Operate: '操作记录',
    MeterList: '设备列表',
    MalfunctionList: '故障列表',
    LeakageList: '渗漏列表',
    OrderList: '订单列表',
    UserProfile: '用户资料',
    Account: '管理员系统',
    AccountInfo: '管理员信息',
    UpdatePassword: '修改密码',
    About: '关于',
    AccountList: '管理员列表',
    Overview: '概览',
    AdminInfo: '管理员信息',
    UserBill: '用户账单',
    CostsSet: '费用设置',
    InstallerUser: '安装人员',
    Message: '消息设置',
    Holiday: '公共假日',
    SystemManagement: '系统设置',
    AdminManagement: '管理员系统',
    CompanyList: '公司列表',
    FirewareList: '固件列表',
    Network: '网络',
    AddRsNetwork: "增加RS485網絡",
    RsNetwork: "RS485網絡",
    AddCompany: '创建公司',
    AddAdmin: '增加管理员',
    AddCostSet: '新增缴费规则',
    AddHoliday: '新增节假日',
    AddUser: '新增用户',
    AddInstallUser: '新增安装人员',
    AddFireware: '新增固件',
    MeterAnalyze: '设备分析',
    UserSetting: '用户设置',
    AddMeter: '新增设备',
    MeterFirewareList: '軟體升級設備列表',
    Devices: '增加刪除設備',
    DeviceControl: '設備控制',
    DeviceSchedule: '设备时间表',
  },
  navbar: {
    logOut: '退出登录',
    dashboard: '首页',
    github: '项目地址',
    theme: '换肤',
    size: '布局大小',
  },
  common: {
    warning: '警告',
    success: '成功',
    company: '公司',
    name: '名称',
    batchManager: '批量管理',
  },
  moneyUnit: {
    unit: '计费单位',
    JPY: 'JPY',
    CNY: 'CNY',
    USD: 'USD',
  },
  language: {
    name: '语言',
    CN: '中文',
    JAP: '日本語',
    English: 'English',
  },
  login: {
    title: '系统登录',
    logIn: '登录',
    rememberMe: '自动登录',
    username: '账号',
    password: '密码',
    comfirmPassword: '确认密码',
    any: '随便填',
    thirdparty: '第三方登录',
    forgetPassword: '忘记密码?',
    sendCode: '发送验证码',
    verificationCode: '邮箱验证码',
  },
  documentation: {
    documentation: '文档',
    github: 'Github 地址',
  },
  permission: {
    addRole: '新增角色',
    editPermission: '编辑权限',
    roles: '你的权限',
    switchRoles: '切换权限',
  },
  meterState: {
    s10: '电池电压',
    s11: '阀门状态',
    s12: '盒盖',
    s13: '时钟同步',
    s14: '泄漏',
    s15: '逆流',
    s16: '超大流量',
    s17: '通讯事件发生',
    s18: '水表事件发生',
    s21: '断电',
    s24: '保电状态',
    s25: '定时开关设定',
    s26: '电网电压',
    s28: '电表事件发生',
    s32: '停气',
    s35: '压力',
    s36: '震动',
    s48: '热表事件发生',
    s50: '电池电压',
    s51: 'WiSUN通讯',
    s54: '日照传感器异常',
    fault: '故障',
    s58: '电表事件发生',
    leakage: '渗漏',
    noData: '4小时无数据',
  },
  usage: {
    usage: '用量',
    importEngery: '输入量',
    exportEnergy: '输出量',
    pVEnergy: '发电量',
    current: '電流值',
    voltage: '電壓值',
    frequency: '頻率值',
    current1: "電流值1",
    voltage1: "電壓值1",
    frequency1: "頻率值1",
    activePower1: '有效电力1',
    reactivePower1: '无效电力1',
    current2: "電流值2",
    voltage2: "電壓值2",
    frequency2: "頻率值2",
    activePower2: '有效电力2',
    reactivePower2: '无效电力2',
    activePower: '有效电力',
    reactivePower: '无效电力',
    pyranometer: '日照计',
    pulseCountUsage: "脈衝輸入用量",
    temperature: "溫度",
    humidity: "濕度",
    routeBImportEnergy: "RouteB 输入量",
    routeBExportEnergy: "RouteB 输出量",
    pvExportEnergyUsage: "PV Export Energy",
  },
  table: {
    dynamicTips1: '固定表头, 按照表头顺序排序',
    dynamicTips2: '不固定表头, 按照点击顺序排序',
    dragTips1: '默认顺序',
    dragTips2: '拖拽后顺序',
    title: '标题',
    importance: '重要性',
    type: '类型',
    remark: '点评',
    search: '搜索',
    add: '添加',
    export: '导出',
    reviewer: '审核人',
    id: '序号',
    date: '时间',
    author: '作者',
    readings: '阅读数',
    status: '状态',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定',
    update: '更新',
    update1: '更新',
    new: '新增',
    chart: '图表',
    map: '地图',
    reset: '重置',
    send: '发送',
    startTime: '开始时间',
    endTime: '结束时间',
    nextPage: '下一页',
    prePage: '上一页',
    createTime: '创建时间',
    preUpdate: '预更新',
    detail: '查看',
    updateDate: '更新日期',
    disable: '停用',
    enable: '使用',
    disableState: '停用状态',
    return: '返回',
    clearForm: '清除表格',
    set: '設置',
    get: '獲取',
    upload: "上传",
    browse:"浏览",
    crc:"CRC",
    meter:"Meter"
  },
  element: {
    pleaseEnter: '请输入',
    pleaseSelect: '请选择',
    inputKeyWords: '请输入关键词',
    selectDate: '选择日期',
    selectDateTime: '选择日期时间',
    selectMultiDate: '选择一个或多个日期',
    selectAll: "全選",
    check: "勾選",
  },
  excel: {
    export: '导出',
    selectedExport: '导出已选择项',
    placeholder: '请输入文件名(默认excel-list)',
    refresh: '刷新',
  },
  tagsView: {
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有',
  },
  company: {
    name: '公司名称',
    logo: '公司logo',
    address: '公司地址',
    webURL: '公司官网',
    email: '公司邮箱',
    phone: '公司电话',
    parentCompanyName: '所属公司',
    messageDate: '消息发送日期',
    paymentDate: '结账日期',
    zone: '时区',
    disableCompany: '停用公司',
    enableCompany: '使用公司',
    leakageSetting: '泄漏百分比',
    waterLeakage: '水表泄漏',
    powerLeakage: '电表泄漏',
    gasLeakage: '气表泄漏',
    hotLeakage: '热表泄漏',
  },
  fireware: {
    name: '固件名称',
    url: '固件地址',
    uploadFireware: '上传固件',
    upload: '上传',
    version: '版本号',
    deleteFireware: '删除固件',
    pleaseSelectFireware: '請選擇軟體',
    note: '備註',
    moduleModel: '數據模組型號',
    firmwareFileSize: '軟體檔案大小',
    selectFirmwae: '選取軟體',
    selectedMeters: '選取設備',
    uploadMeters: '上載設備',
    uploadFile: '上載檔案'
  },
  meter: {
    meterID: '设备ID',
    subPowerMeter: "コレクタメーター",
    meterType: '设备类型',
    ownUser: '所属用户',
    setMeterParent: '设置上级',
    changeMeterParent: '更换上级',
    parentMeterID: '上级设备ID',
    unitPrice: '单价',
    addMeterCost: '新增计费规则',
    updateMeterCost: '查看计费规则',
    deleteMeterCost: '删除计费规则',
    leakageQuantity: '渗漏量',
    reportTime: '上传时间',
    maintainReportTime: '维修时间',
    faultType: '故障类型',
    life: '寿命',
    maxReading: '最大读数',
    bRouteMaxReading: 'Route B 最大读数',
    cycle: '维护周期',
    installDate: '安装日期',
    state: '设备状态',
    address: '地址',
    parentMeter: '父级设备',
    usage: '消耗',
    reads: '读数',
    cost: '花费',
    expireDate: '到期日期',
    selectTime: '选择时间',
    message: '消息',
    batchSetParent: '设置上级',
    batchWrite: '发送设备包',
    reading: '实时抄表',
    ota: 'ota升级',
    broute: 'B-路径',
    brouteID: 'B-路径ID',
    brouteSecret: 'B-路径密码',
    GetInfo: "取得",
    openValve: '打开阀门/继电器',
    closeValve: '关闭阀门/继电器',
    clockSync: '时钟同步',
    electric: '保电',
    openLoad: '打开负载开关',
    closeLoad: '关闭负载开关',
    loadControl: '负载开关控制',
    timeSwitchcontrol: '定时开关控制',
    otherControl: '其他控制',
    alarm: '报警',
    alarmList: '报警列表',
    installerUser: '安装人员',
    bindUser: '绑定用户',
    analyze: '分析',
    deleteMsheeter: '是否删除该设备?',
    disableMeter: '停用設備',
    enableMeter: '使用設備',
    meterReading: '設備读数',
    eventLog: '事件記錄',
    eventLogForRs485: '事件記錄(for RS485 Slave)',
    clearKey: "清除秘钥",
    resetPointer: "重置數據指针",
    resetMeter: "重置設備",
    resetCommModule: "重置模組",
    resetDailyMeter: "每日重置設定",
    selectLocation: "选择地址",
    powerConditioner: "外部装置",
    Instant: '实时抄表',
    RangedEnergyReading: '时间范围抄表 (for RS485 Slave)',
    RangedEventLog: '时间范围事件記錄',
    InstantPowerLineValue: '实时电力品质数据',
    ReadPowerLineValue: '讀取電力線數值',
    GetVersionInfo: '取得設備ID及軟體版本資訊',
    Get30minRecordLogWithVoltage: "取得包含電壓30分鐘記錄",
    Get30minRecordLog: "取得30分鐘記錄",
    GetDiagnosticInformation: "取得診断資訊",
    DiagnosticInformation: "診断資訊",
    ConfirmClearKey: '警告: 是否確定清除秘钥?',
    versionCheck: '檢查軟體版本資訊',
    upgrade: '軟體升級',
    batchUpgrade: '批量升級',
    subMeter: '子錶',
    NetworkName: "網絡名稱",
    NetworkBaudRate: "網絡波特率",
    Master: '主錶',
    Slave: '子錶',
    NumberOfSlaveNumber: 'Number of Slave Number',
    ControlPanel: "控制台",
    Advance: '進階',
    SlaveMeterID: '子錶設備ID',
    UnitNO: '子錶編號',
    ManualCommand: '手動命令',
    AdvanceCommands: '進階命令',
    Response: '回應',
    LastReportTime: '最後更新',
    Import: "輸入量",
    Export: "輸出量",
    PulseInputCount: "脈衝用量",
    MeterStatu: "設備狀態",
    Current: "電流值",
    Voltage: "電壓值",
    Frequency: "頻率值",
    Start: "起始",
    End: "結束",
    Command: '命令',
    readingRecords: '电表记录',
    reCalculateUsage: "重置数据",
    meterVersion: '設備軟體',
    moduleId: '模組ID',
    moduleVersion: '模組軟體版本',
    pulseFactor: "變換率",
    simCardInfo: "SIM卡設定",
    imsi: "IMSI",
    apn: "APN",
    user: "User",
    password: "密碼",
    authenication: "驗證類型",
    authenicationTypes: ["無", "PAP", "CHAP", "PAP或CHAP"],
    ipAddressAndPort: "IP地址及通訊埠",
    ipAddress: "IP地址",
    port: "通訊埠",
    atuoRead: "自動讀取",
    wifi: "Wi-Fi",
    wifiSSID: "Wi-Fi SSID",
    wifiPassword: "Wi-FI Password",
    sta: "STA",
    staSSID: "STA SSID",
    staPassword: "STA Password",
    mqttType: "伺服器類型",
    powerPlantId: '發電廠號',
    uploadSchedule: '上载控制日',
    cpc:'Program CPC',
    rs485SwitchControl:'RS485開關控制'
  },
  schedule: {
    stableSchedule:"固定控制日程",
    stableVersion:"固定控制版本",
    updateSchedule:"更新控制版本",
    updateVersion:"更新控制版本",
    updateInterval:"更新时间间隔",
    count:"提供数据量",
    scheduleUpload:"上传控制日志介面"
  },
  device: {
    device: "設備",
    class: 'Class',
    className: 'Class名稱',
    deviceId: '設備ID',
    status: '狀態',
    inUse: '使用中',
    getProperty: "取得属性",
    oneProperty: "單個属性",
    mulitProperty: "多個属性",
    propertyName: "属性名稱",
    epc: "EPC",
    accessRule1: "accessRule1",
    accessRule2: "accessRule2",
    readingInputData: "數據 - 讀取/輸入",
    lastUpdateOn: "最後更新時間",
    remarks: "備註",
    sequenceOfData: "讀寫順序",
    downloadBuffer: "下載缓冲",
    reloadBuffer: "更新缓冲",
    scheduleJson: "定时JSON命令"
  },
  message: {
    maintenancePlan: '维护计划',
    expireMessage: '到期提醒',
    preNotifyDays: '提前{0}天通知',
    NotifyDays: '每月{0}号通知',
    defaultSevenDays: '默认提前7天',
  },
  location: {
    location: '定位',
    latlng: '经纬度',
    longitude: ' 经度',
    latitude: '纬度',
    country: '国家',
    province: '省份',
    city: '城市',
    detail: '详细地址',
    street: '街道',
    meterCount: '设备数量',
    userCount: '用户数量',
    totalUsage: '总消耗量',
    totalCost: '总费用',
  },
  diableState: {
    disabled: '停用中',
    enabled: '使用中',
  },
  meterTypes: {
    water: '水表',
    power: '电表',
    gas: '气表',
    hot: '热表',
    pv: 'pv表',
  },
  meterTypeArray: ['水表', '电表', '气表', '热表', 'pv表', '電錶網關', '電錶網關wifi'],
  subMeterTypeArray: [
    ["Non-Pulse Type", "Remote unit", "Pluse Type"],
    ["Sub Meter", "Sub Meter with Pulse input", "Sub Meter RS485 - Master", "Sub Meter RS485-Slave"],
    ["Non-Pulse Type", "Remote unit", "Pluse Type"],
    [],
    ["Single Direction ", "Bi-Direction"],
    [],
  ],
  firmwareType: {
    water: '水表',
    power: '电表',
    gas: '气表',
    hot: '热表',
    pv: 'pv表',
    gateway: '電錶網關',
    gateway_wifi: '電錶網關wifi',
    cert:"Cert",
    ca_cert: 'CA cert',
    client_cert: 'Client cert',
    client_key: 'Client key',
    pcs_ca_ert:'PCS CA cert',
  },
  timeArray: {
    hours: '24小时',
    days: '7天',
    weeks: '最近4周',
    months: '最近12个月',
    years: '最近5年',
  },
  stateInfos: {
    totalCount: '设备总数',
    malfunctionCount: '故障总数',
  },
  date: {
    year: '年',
    month: '月',
    day: '天',
  },
  user: {
    email: '邮箱',
    userID: '用户ID',
    userName: '用户名',
    portrait: '头像',
    address: '用户住址',
    editUser: '编辑用户',
    phone: '手机号码',
    password: '密码',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    deleteUser: '删除用户',
    frontRole: '前端角色',
    backRole: '后端角色',
    role: '角色',
    position: '职位',
    disableAdmin: '停用管理员',
    enableAdmin: '使用管理员',
    disableUser: '停用用户',
    enableUser: '使用用户',
  },
  order: {
    payTime: '支付时间',
    createTime: '创建时间',
    money: '支付金额',
    payState: '支付状态',
    alredayPay: '已支付',
    notPay: '未支付',
    sendEmail: '发送邮件',
  },
  costSet: {
    name: '缴费策略',
    normal: '计费规则',
    addHolidayDate: '增加时间段',
    saturday: '星期六',
    sunday: '星期天',
    holiday: '公共假日',
    addRule: '增加计费规则',
    ruleType: '计费类型',
    timeRule: '按时计费',
    usageRule: '按量计费',
    startTime: '起始时间',
    endTime: '结束时间',
    startUsage: '起始用量',
    endUsage: '结束用量',
    please_input_usage: '请填写用量',
    please_input_end_usage: '请填写用量,默认最大值99999999',
    nextCostSet: '预缴费计划',
    nextCostSetDate: '预更新时间',
  },
  operate: {
    action: '行为',
    path: '路径',
  },
  notification: {
    alreadyLastPage: '已经是最后一页了',
    pleaseInputAllAddressInfo: '请填入完全的地址信息',
    pleaseInputName: '请输入名字',
    pleasePickOneDateAtLeast: '请至少选择一个日期',
    saveSuccess: '保存成功',
    saveFail: '保存失败',
    pleaseInputAll: '请填写完整信息',
    inputIllegal: '输入不合法',
    addCompanySuccess: '添加公司成功!',
    addAdminSuccess: '添加管理员成功!',
    getEmailSuccess: '获取邮箱成功!',
    changePasswordSuccess: '设置密码成功!',
    addHolidaySuccess: '添加公共假日成功!',
    getEmailError: '获取验证码失败!',
    emailCodeAlreadySend: '验证码已经发送',
    dataPackageSendSuccess: '数据包发送成功!',
    addUserSuccess: '添加用户成功!',
    addInstallUserSuccess: '添加安装人员成功!',
    updateUserInfoSuccess: '修改个人信息成功!',
    AddFirewareSuccess: '增加固件成功!',
    AddMeterCostSuccess: '添加计费计划成功',
    DeleteMeterCostSuccess: '删除计费计划成功!',
    BatchSetParentSuccess: '批量设置设备上级成功!',
    BatchBindUserSuccess: '批量绑定用户成功!',
    BatchBindMeterCostSuccess: '批量绑定缴费策略成功!',
    PleaseSelectMeterID: '请选择设备ID',
    PleaseSelectUser: '请选择用户',
    PleaseSelectMeterCoust: '请选择缴费策略',
    UpdateAdminSuccess: '更新管理员信息成功!',
    DeleteAdminSuccess: '删除管理员成功!',
    UpdatePasswordSuccess: '修改密码成功,请重新登录!',
    MeterCostDateError: '缴费计划更新时间不合法!',
    UploadSuccess: '上传成功!',
    DisableCompanySuccess: '停用公司成功!',
    EnableCompanySuccess: '使用公司成功!',
    DisableAdminSuccess: '停用管理员成功!',
    EnableAdminSuccess: '使用管理员成功!',
    DisableMeterSuccess: '停用设备成功!',
    EnableMeterSuccess: '使用设备成功!',
    DateRangeHaveNoData: '时间范围内没有数据!',
  },
  validate: {
    onlyNumberPermission: '值只能是数字',
    cannotGreaterThan30: '值不能大于30',
    passwordMustGreaterThan8: '密码必须大于8位数',
    twoPasswordNotEqual: '两次输入密码不一致!',
    email: '请输入正确的邮箱',
    valueNotNull: '值不能为空',
  },
  param: {
    param1: '参数1',
    param2: '参数2',
    param3: '参数3',
    startTime: '开始时间',
    endTime: '结束时间',
  },
  routeDetail: {
    adminSignIN: '管理员登录',
    adminSignUP: '管理员注册',
    adminLogout: '管理员退出登录',
    getAdminList: '获取管理员列表',
    updateAdminPassword: '更新管理员密码',
    updateAdmin: '更新管理员信息',
    deleteAdmin: '删除管理员',
    createInstallUser: '创建安装用户',
    forgetAdminPassword: '忘记密码',
    addPermissions: '增加管理员权限',
    deletePermissions: '删除管理员权限',
    bindRole: '增加管理员角色',
    updateRole: '更新管理员角色',
    deleteRole: '删除管理员角色',
    users: '获取用户列表',
    addMeter: '增加设备',
    updateMeter: '更新设备',
    meters: '获取设备列表',
    setMeterParent: '设置设备上级',
    changeMeterParent: '更改设备上级',
    leakages: '获取渗漏设备列表',
    orders: '账单列表',
    meterFaults: '设备故障消息',
    addMeterCost: '新增收费计划',
    deleteMeterCost: '删除收费计划',
    updateMeterCost: '更新收费计划',
    getMeterCosts: '获取收费计划列表',
    addHolidaysDate: '增加节假日',
    deleteHolidaysDate: '删除节假日',
    updateHolidaysDate: '更新节假日',
    getHolidaysDates: '获取节假日列表',
    createCompany: '创建公司',
    deleteCompany: '删除公司',
    updateCompany: '更新公司信息',
    getCompanys: '获取公司列表',
    createFireware: '新建固件',
    deleteFireware: '删除固件',
    updateFireware: '更新固件',
    getFirewares: '获取固件列表',
    exportMeterDatas: '导出设备数据',
  },
  brandNames: ['OMRON', 'DeltaOHM', "Huawei", "Panasonic","IIL"],
  ModelNames: ['KP_M', 'KPK / KPV / KPW', 'HD9817TVS', 'SUN2000L-5ktl', 'VBPC244GM2S',"IIL2312"],
  Model2DataItems: ['直流輸入電壓 [1]', '直流輸入電壓 [2]', '直流輸入電壓 [3]', '直流輸入電壓 [4]', '直流輸入電流 [1]', '直流輸入電流 [2]', '直流輸入電流 [3]',
    '直流輸入電流 [4]', '直流輸入電流 (總輸入)', '生產電力', '系統W相電壓', '系統U相電壓', '系統頻率', '總累積電力量', '工作狀態', '顯示故障碼', '定額輸出'],
  Model1DataItems: ['工作狀態', '直流輸入電壓', '直流輸入電流', '系統U相電壓', '系統W相電壓', '生產電力', '日照強度', '溫度', '總累積電力量', '用戶累積電力量', '直流輸入電壓 [1]',
    '直流輸入電流 [1]', '直流輸入電壓 [2]', '直流輸入電流 [2]', '直流輸入電壓 [3]', '直流輸入電流 [3]', '直流輸入電壓 [4]', '直流輸入電流 [4]'],
  Model3DataItems: ["溫度", "溫度", "相對濕度", "露點", "露點", "濕球溫度", "濕球溫度", "狀態寄存器"],
  ModelHuaweiDataItems: ['Model', 'SN', 'PN', 'Model ID', 'Number of PV strings', 'Number of MPP trackers', 'Rated power (Pn)', 'Maximum active power (Pmax)', 'Maximum apparent power(Smax)', 'Maximum reactive power(Qmax fed to the power grid)',
    'Maximum reactive power(Qmax absorbed from the power grid)', 'State 1', 'State 2', 'State 3', 'Alarm 1', 'Alarm 2', 'Alarm 3', 'PV1 voltage', 'PV1 current', 'PV2 voltage',
    'PV2 current', 'PV3 voltage', 'PV3 current', 'PV4 voltage', 'PV4 current', 'Input power', 'Power grid voltage/Line voltage between phases A and B', 'Line voltage between phases B and C', 'Line voltage between phases C and A', 'Phase A voltage',
    'Phase B voltage', 'Phase C voltage', 'Power grid current/Phase A current', 'Phase B current', 'Phase C current', 'Peak active power of current day', 'Active power', 'Reactive power', 'Power factor', 'Grid frequency',
    'Efficiency', 'Internal temperature', 'Insulation resistance', 'Device status', 'Fault code', 'Startup time', 'Shutdown time', 'Accumulated energy yield', 'Daily energy yield', '[Energy storage] Rated capacity', '[Energy storage] Remaining capacity"',
    '[Energy storage] Running status', '[Energy storage] Main Line voltage', '[Energy storage] Main Line current', '[Energy storage] Charge and discharge power', '[Energy storage] Accumulated charge capacity', '[Energy storage] Accumulated discharge capacity',
    '[Energy storage] Current-day charge capacity', '[Energy storage] Current-day discharge capacity'],
  VBPC244GM2SDataItems:['Operation status', 'Abnormality contents', 'Grid linkage status', 'Linkage input/output instant power', 'Linkage output accumulated power',
    'Independent input/output instant power','Independent output accumulated power', 'Solar generation instant power', 'Solar generation accumulated power', 'Solar generation limit setting 2 (Power)', 
    'Selling power limit setting (Power)', 'Output control judgement', 'Panel capacity'],
  ModelIILDataItems:["Voltage (Factor 0.1, unit V)","Current (Factor 0.01, unit A)","Power (Factor 0.1, unit W (signed))","Total energy (Factor 0.01, unit kWh)","Measure voltage direction (0: Forward 1: Backward)","Total energy (Total energy )","Import energy (Factor 0.01, unit kWh)","Export energy (Factor 0.01, unit kWh)","Import energy (Factor 0.001, unit kWh)","Export energy (Factor 0.001, unit kWh)","Current (Factor 0.01, unit A (signed))","Import power (Factor 0.1, unit W (signed))","Export power (Factor 0.1, unit W (signed))","Voltage high-byte (Factor 0.01, unit V)","Current (Factor 0.001, unit A (signed))","Power (Factor 0.001, unit W (signed))"],
  powerConditioner: {
    content: '内容',
    data: '数据',
    brand: '品牌',
    mode: '型号',
    node: '节点',
    baudRate: '波特率',
    command: '項目',
    lastReportTime: '最后报告时间',
    responseCode: '回覆碼',
    selectBrand: '請選擇品牌',
    selectModel: '請選擇型号',
    selectNode: '請選擇节点',
    selectCommand: '請選擇項目',
    inputBaudRate: '請選擇波特率',
    allCommand: '所有命令',
    onlyOneMeterSupport: '只能选择一个设备进行逆變器设置',
    onlyPvMeterCanHandlePowerConditioner: '只有pv表才能操作逆變器',
  },
  ErrorMsg: {
    1008: '请等待外部设备回复',
  },
  RsNetworkInstantValueCommandNames: ['Meter ID|0000|03', 'Meter Model|0003|03', 'QR code string|0006|08',
    '1st phase Voltage|000e|01', '1st phase Current|000f|01', '1st phase Frequency|0010|01', '1st phase Active Power|0011|01', '1st phase Reactive Power|0012|01',
    '2nd phase Voltage|0013|01', '2nd phase Current|0014|01', '2nd phase Frequency|0015|01', '2nd phase Active Power|0016|01', '2nd phase Reactive Power|0017|01',
    '3rd phase Voltage|0018|01', '3rd phase Current|0019|01', '3rd phase Frequency|001a|01', '3rd phase Active Power|001b|01', '3rd phase Reactive Power|001c|01',
    'Active Power|001d|01', 'Reactive Power|001f|01', 'Import Energy|0020|01', 'Export Energy|0021|01', 'Accumulate Pulse count|0022|01', 'Meter Status bit (0-9)|0023|01',
    'Route B Data Timetamp|0024|01', 'Route B Import Energy|0025|01', 'Route B Export Energy|0026|01', 'Route B 30m Data Timestamp|0027|01', 'Route B 30m Import Energy|0028|01', 'Route B 30m Export Energy|0029|01', 'Wi-SUN Status Timestamp|002a|01', 'Wi-Sun Status|002b|01',
    'Get all data|1111|44'],
  electricRecordDays: ["當天", "昨天", "2 天前", "3 天前", "4 天前", "5 天前", "6 天前", "7 天前", "8 天前", "9 天前",
    "10 天前", "11 天前", "12 天前", "13 天前", "14 天前", "15 天前", "16 天前", "17 天前", "18 天前", "19 天前",
    "20 天前", "21 天前", "22 天前", "23 天前", "24 天前", "25 天前", "26 天前", "27 天前", "28 天前", "29 天前",
    "30 天前", "31 天前", "32 天前", "33 天前", "34 天前", "35 天前", "36 天前", "37 天前", "38  天前", "39 天前",
    "40 天前", "41 天前", "42 天前", "43 天前", "44 天前"],
  mqttType: {
    normal: "MQTT",
    tsl: "MQTT with TSL",
    aws: "AWS MQTT"
  }
};

